import {
  includedOptions,
  maintenanceSLAOptions,
} from "@/common/const/filter-options";
import maintenanceTypeOptions from "@/common/const/filter-options/maintainanceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { FormFieldsStrategyType } from "@/common/types";

const networkManualFormStrategy: FormFieldsStrategyType[] = [
  {
    inputType: "text",
    label: "OEM/Manufaturer Name",
    name: "manufaturerName",
    required: true,
  },
  {
    inputType: "text",
    label: "Product Code/Part Number",
    name: "productCode",
    required: true,
  },
  {
    inputType: "select",
    label: "Purchase Type",
    name: "purchaseType",
    defaultValue: "Resale",
    required: true,
    options: [
      { label: "Resale", value: "Resale" },
      {
        label: "Rental",
        value: "Rental",
      },
    ],
  },
  {
    inputType: "select",
    label: "Maintenance Type",
    name: "maintenanceType",
    required: true,
    defaultValue: maintenanceTypeOptions[0].value,
    options: maintenanceTypeOptions,
  },
  {
    inputType: "select",
    label: "Maintenance SLA",
    name: "maintenanceSla",
    required: true,
    options: maintenanceSLAOptions,
    defaultValue: maintenanceSLAOptions[0].value,
  },
  {
    inputType: "select",
    label: "Maintenance Status",
    name: "maintenanceStatus",
    required: true,
    options: includedOptions,
    defaultValue: includedOptions[0].value,
  },
  {
    inputType: "text",
    label: "License Name",
    name: "licenseName",
    required: true,
  },
  {
    inputType: "select",
    label: "License Status",
    name: "licenseStatus",
    required: true,
    options: includedOptions,
    defaultValue: includedOptions[0].value,
  },
  {
    inputType: "select",
    label: "Contract Term",
    name: "contractTerm",
    required: true,
    defaultValue: "1",
    options: [...contractTermsOptions],
  },
];
export default networkManualFormStrategy;
